import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Result, Button, Card, Spin } from 'antd';
import { CloseCircleOutlined, HomeOutlined } from '@ant-design/icons';
import Layout from '../../components/Common/Layout/Layout';
import { ApiDefinition } from '../../config';
import { firstQueryParam } from '../../utils/paymentQueryParams';

const PaymentFail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    const processPayment = async () => {
      try {
        setLoading(true);
        
        // URL parametrelerini al
        const siparisFromUrl = firstQueryParam(searchParams, ['Siparis_ID', 'siparis_id', 'SIPARIS_ID']);
        const siparisId =
          siparisFromUrl ||
          localStorage.getItem('pendingPaymentOrderId') ||
          localStorage.getItem('pendingAdvertisementPaymentOrderId');
        const sonuc = firstQueryParam(searchParams, ['Sonuc', 'sonuc', 'SONUC']);
        const sonucStr = firstQueryParam(searchParams, ['Sonuc_Str', 'sonuc_str', 'SONUC_STR', 'SonucStr', 'sonucstr']);

        // Backend callback endpoint'ine bilgi gönder (fromFrontend=true ile)
        if (siparisId) {
          try {
            const apiUrl = ApiDefinition.apiUrl;
            const callbackUrl = `${apiUrl}/api/subscription/payment/fail?Siparis_ID=${encodeURIComponent(siparisId)}&Sonuc=${encodeURIComponent(sonuc || '')}&Sonuc_Str=${encodeURIComponent(sonucStr || '')}&fromFrontend=true`;
            
            // Backend callback'i çağır - backend işlemi yapacak
            const response = await fetch(callbackUrl, {
              method: 'GET',
              credentials: 'include'
            });
            
            if (response.ok) {
              const result = (await response.json()) as {
                message?: string;
                recoverable?: boolean;
                redirectPath?: string;
              };
              if (result?.recoverable && result?.redirectPath) {
                navigate(result.redirectPath, { replace: true });
                return;
              }
              setMessage(result.message || sonucStr || 'Ödeme işlemi başarısız oldu.');
            } else {
              setMessage(sonucStr || 'Ödeme işlemi başarısız oldu.');
            }
          } catch (error) {
            console.error('Payment callback error:', error);
            setMessage(sonucStr || 'Ödeme işlemi başarısız oldu.');
          }
        } else {
          // Direkt status parametresi varsa
          const status = firstQueryParam(searchParams, ['status', 'STATUS']);
          const statusMessage = firstQueryParam(searchParams, ['message', 'Message', 'msg']);
          const urlFailReason = sonucStr
            || statusMessage
            || firstQueryParam(searchParams, ['Sonuc_Str', 'sonuc_str', 'error', 'Error', 'errorMessage']);
          
          if (status === 'error') {
            setMessage(urlFailReason || 'Ödeme işlemi başarısız oldu.');
          } else {
            setMessage(
              urlFailReason ||
                'Ödeme referansı URL üzerinde yok. Param Fail/Başarı adreslerinin API callback (api.menteem.com.tr/api/subscription/payment/…) olduğundan emin olun; abonelik için panelden tekrar deneyin.'
            );
          }
        }
      } catch (error) {
        console.error('Payment processing error:', error);
        setMessage('Ödeme işlemi sırasında bir hata oluştu.');
      } finally {
        setLoading(false);
      }
    };

    processPayment();
  }, [searchParams]);

  return (
    <Layout>
      <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
        <Card style={{ maxWidth: 600, width: '100%' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <Spin size="large" />
              <p style={{ marginTop: '16px', color: '#666' }}>Ödeme işlemi kontrol ediliyor...</p>
            </div>
          ) : (
            <Result
              status="error"
              icon={<CloseCircleOutlined style={{ color: 'var(--error)', fontSize: '72px' }} />}
              title="Ödeme Başarısız"
              subTitle={message || 'Ödeme işlemi tamamlanamadı. Lütfen tekrar deneyin veya farklı bir ödeme yöntemi kullanın.'}
              extra={[
                <Button
                  key="home"
                  type="primary"
                  icon={<HomeOutlined />}
                  onClick={() => navigate('/')}
                  size="large"
                >
                  Ana Sayfaya Dön
                </Button>
              ]}
            />
          )}
        </Card>
      </div>
    </Layout>
  );
};

export default PaymentFail;

